// extracted by mini-css-extract-plugin
module.exports = {"layout":"styles_layout__-sf04"};